const paidTokens = new Set([
  "1",
  1,
  "true",
  "paid",
  "paid account",
  "premium",
  "completed",
  "active",
  "yes",
]);

const suspendedTokens = new Set([
  "1",
  1,
  "true",
  "suspended",
  "suspend",
  "blocked",
  "disabled",
  "yes",
]);

export const getBureauWebsiteUrl = (bureau?: {
  websiteUrl?: string | null;
  bureauId?: string | null;
  bureauName?: string | null;
} | null): string => {
  const website = bureau?.websiteUrl?.trim();
  if (website) {
    try {
      const url = new URL(
        /^https?:\/\//i.test(website) ? website : `https://${website}`,
      );
      const hostname = url.hostname.toLowerCase();
      if (
        ["http:", "https:"].includes(url.protocol) &&
        hostname.includes(".") &&
        hostname !== "localhost" &&
        !hostname.endsWith(".localhost") &&
        !hostname.startsWith("127.") &&
        hostname !== "0.0.0.0" &&
        hostname !== "10.0.2.2"
      ) {
        return url.href;
      }
    } catch {
      // Fall back to the bureau's public website when its saved URL is invalid.
    }
  }

  if (!bureau?.bureauId) return "";
  const name = (bureau.bureauName ?? "").trim().replace(/\s+/g, "");
  return `https://matrimonystudio.in/${encodeURIComponent(bureau.bureauId)}/${encodeURIComponent(name)}`;
};

/**
 * Determines whether the current bureau has an active membership.
 * Accepts multiple representations (number, string, boolean) so we
 * can trust this check across different API payloads.
 */
export const hasActiveMembership = (
  status: unknown | null | undefined
): boolean => {
  if (typeof status === "number") return status === 1;
  if (typeof status === "boolean") return status;
  if (typeof status === "string") {
    const normalized = status.trim().toLowerCase();
    if (!normalized.length) return false;
    if (paidTokens.has(normalized)) return true;
    const numeric = Number(normalized);
    if (!Number.isNaN(numeric)) {
      return numeric === 1;
    }
    return false;
  }
  return false;
};

export const isAccountSuspended = (
  status: unknown | null | undefined
): boolean => {
  if (typeof status === "number") return status === 1;
  if (typeof status === "boolean") return status;
  if (typeof status === "string") {
    const normalized = status.trim().toLowerCase();
    if (!normalized.length) return false;
    if (suspendedTokens.has(normalized)) {
      return true;
    }
    const numeric = Number(normalized);
    if (!Number.isNaN(numeric)) {
      return numeric === 1;
    }
  }
  return false;
};
